import _typeof from "@babel/runtime/helpers/esm/typeof";
var requestAnimationFrame = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.requestAnimationFrame ? window.requestAnimationFrame : function (fn) {
  return setTimeout(fn, 16);
};
export { requestAnimationFrame };